import React, { useContext, useEffect, useRef, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { loadMorePatients } from '../../redux/Patient/PatientAction';
// import DOWNLOAD_ICON from '../../assets/images/download.png';
import PatientItem from './PatientItem.jsx';
import MessagesContext from '../../contexts/messagesContext';
import LanguageContext from '../../contexts/languageContext';
import { useStyles } from './AllPatients.styles';
import useCheckMobileScreen from '../../hooks/useWidth';
import AppBar from '../AppBar';
import notExistPatient from '../../assets/images/notExistPatients.svg';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/Patient/PatientType';
import { getClinicId } from '../../utils/storage';

const LIMIT = 20;
// const reportFormat = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const AllPatients = () => {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const header = [
        { label: `${messages.fullName}`, class: 'overall' },
        { label: messages.creationDate, class: 'lastVisitDate' },
        // { label: messages.time, class: 'lastVisitTime' },
        { label: messages.age, class: 'age' },
        { label: messages.NID, class: 'NID' },
        { label: messages.phoneNo, class: 'phone' },
        { label: messages.attendingClinics, class: 'clinic' }
    ];
    const dispatch = useDispatch();
    const isMobile = useCheckMobileScreen();
    const { list, loadMore } = useSelector((state) => state.patient?.allPatients);
    const loadingSelector = createLoadingSelector(type.LOAD_PATIENTS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const classes = useStyles({ length: list?.length, rtl: lang === 'fa' });
    const workspace = useSelector((state) => state.user?.workspace);
    const loader = useRef(null);
    const [page, setPage] = useState(0);
    const [loadingMore, setLoadingMore] = useState(false);
    const [activePatientId, setActivePatientId] = useState(null);
    const length = list?.length;
    const workspaceId = workspace?.clinic?.id;
    const clinicId = getClinicId();

    // const handleObserver = useCallback((entities) => {
    //     const target = entities[0];
    //     if (target.isIntersecting) {
    //         setPage((page) => page + 1);
    //         setLoading((loading) => !loading);
    //     }
    // });

    useEffect(() => {
        const params = {
            clinic: clinicId,
            offset: 0,
            limit: LIMIT
        };
        dispatch(loadMorePatients(params));
        setPage(0);
        setLoadingMore(true);
    }, [workspaceId, clinicId]);

    useEffect(() => {
        const params = {
            clinic: clinicId,
            offset: page * LIMIT,
            limit: LIMIT
        };
        if (page) {
            dispatch(loadMorePatients(params));
            setLoadingMore(true);
        }
    }, [page]);
    useEffect(() => {
        if (length !== undefined && length !== null) {
            setLoadingMore(false);
        }
    }, [length]);
    // useEffect(() => {
    //     let options = {
    //         root: document.getElementById('all-patient-list-container'),
    //         rootMargin: '40px',
    //         threshold: 1.0
    //     };
    //     const observer = new IntersectionObserver(handleObserver, options);
    //     if (loader.current) {
    //         observer.observe(loader.current);
    //         return () => observer.unobserve(loader?.current);
    //     }
    // }, [loader, handleObserver]);

    // const getReport = () => {
    //     dispatch(getAllPatientsReport());
    // };
    const handleOnScroll = (event) => {
        if (loadingMore) return;
        if (
            event.target.scrollHeight - event.target.clientHeight <=
            Math.round(event.target.scrollTop) + 200
        ) {
            setPage((page) => page + 1);
            setLoadingMore(true);
        }
    };
    return (
        <>
            {isMobile ? <AppBar isPatientList /> : null}
            <div className={classes.mainContainer}>
                <div
                    className={classes.container}
                    id="all-patient-list-container"
                    onScroll={(e) => handleOnScroll(e)}
                >
                    {isLoading && (list === null || list === undefined) ? (
                        <div className={classes.loadingContainer} data-testid="loadingContainer">
                            <CircularProgress className={classes.progress} />
                        </div>
                    ) : !list?.length || list === null || list === undefined ? (
                        <div className={classes.loadingContainer} data-testid="loadingContainer">
                            <div className={classes.notExistWrapper}>
                                <img src={notExistPatient} />
                                <span>{messages.notExistPatients}</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <ul className={classes.listContainer}>
                                <li className={classes.headerListItem}>
                                    {header.map((item, index) => (
                                        <div
                                            className={`${classes.header} ${classes[item.class]}`}
                                            key={index}
                                        >
                                            {item.label}
                                        </div>
                                    ))}
                                </li>
                                {list?.map((patient) => (
                                    <PatientItem
                                        patient={patient}
                                        key={patient.id}
                                        hasActiveLinks={Boolean(patient.id === activePatientId)}
                                        handleOpenLinks={(id) => {
                                            activePatientId === id
                                                ? setActivePatientId(null)
                                                : setActivePatientId(id);
                                        }}
                                        // goToPatientPage={goToPatientPage}
                                    />
                                ))}
                            </ul>
                            {loadMore !== 'ALL' && list.length >= 20 && (
                                <div className={classes.loading} ref={loader}>
                                    {' '}
                                    Loading...
                                </div>
                            )}

                            {/* <div className={classes.fixedBtnContainer}>
                        <Button
                            className={
                                isAllPatientsInPatiens
                                    ? classes.allPatientInPatients
                                    : classes.reportBtn
                            }
                            variant="contained"
                            onClick={getReport}
                        > */}
                            {/* <div className={classes.iconContainer}>
                                <div className={classes.base}></div>
                            </div> */}
                            {/* <img
                                style={{ margin: isAllPatientsInPatiens ? ' 0 4px' : '' }}
                                src={DOWNLOAD_ICON}
                                width="17.7"
                                alt="download"
                            />
                            {isAllPatientsInPatiens
                                ? messages.downloadReportInPatients
                                : messages.downloadReports}
                        </Button>
                    </div> */}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default AllPatients;
